import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Button } from '../Button';
import { Checkbox } from '../Checkbox';
import { ActionButtons } from './internal/ActionButtons';
import Divider from '@mui/material/Divider';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MOBILE_PADDING = '16px';
var DESKTOP_PADDING = '24px';
export function DialogFooter(props) {
  var _props$checkbox = props.checkbox,
    checkbox = _props$checkbox === void 0 ? true : _props$checkbox,
    checkboxText = props.checkboxText,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    _props$destructive = props.destructive,
    destructive = _props$destructive === void 0 ? false : _props$destructive,
    _props$divider = props.divider,
    divider = _props$divider === void 0 ? true : _props$divider,
    icon = props.icon,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    onChangeCheckbox = props.onChangeCheckbox,
    onPrimaryButtonClick = props.onPrimaryButtonClick,
    onSecondaryButtonClick = props.onSecondaryButtonClick,
    onTertiaryButtonClick = props.onTertiaryButtonClick,
    primaryButtonProps = props.primaryButtonProps,
    primaryButtonText = props.primaryButtonText,
    secondaryButtonProps = props.secondaryButtonProps,
    secondaryButtonText = props.secondaryButtonText,
    sx = props.sx,
    _props$tertiaryButton = props.tertiaryButton,
    tertiaryButton = _props$tertiaryButton === void 0 ? true : _props$tertiaryButton,
    tertiaryButtonText = props.tertiaryButtonText,
    _props$type = props.type,
    type = _props$type === void 0 ? 'horizontal-fill-container' : _props$type;
  var theme = useTheme();

  //Button width - style
  var buttonWidthStyle = function buttonWidthStyle(buttonType) {
    if (buttonType === 'horizontal') {
      return isMobile ? '100%' : 'fit-content';
    } else if (isMobile) {
      return '100%';
    } else {
      return type === 'vertical-fill-container' ? '100%' : '50%';
    }
  };
  var paddingTop = divider ? 0 : theme.spacing(6);
  var padding = isMobile ? "".concat(paddingTop, " ").concat(MOBILE_PADDING, " ").concat(MOBILE_PADDING, " ").concat(MOBILE_PADDING) : "".concat(paddingTop, " ").concat(DESKTOP_PADDING, " ").concat(DESKTOP_PADDING, " ").concat(DESKTOP_PADDING);
  return /*#__PURE__*/_jsxs(Stack, {
    sx: _extends({}, sx),
    "data-element": "Stack",
    "data-component": "DialogFooter",
    "data-source-file": "DialogFooter.tsx",
    children: [divider && /*#__PURE__*/_jsx(Box, {
      className: "dialog-footer-divider",
      children: /*#__PURE__*/_jsx(Divider, {
        color: theme.palette.gray[200],
        sx: {
          height: '1px'
        }
      })
    }), type !== 'horizontal-right-aligned' ? /*#__PURE__*/_jsx(Stack, {
      className: "fill-container-stack",
      gap: 3,
      sx: {
        flexDirection: type === 'vertical-fill-container' || isMobile ? 'column-reverse' : 'row',
        padding: padding
      },
      children: /*#__PURE__*/_jsx(ActionButtons, {
        buttonWidthStyle: buttonWidthStyle('vertical'),
        destructive: destructive,
        onPrimaryButtonClick: onPrimaryButtonClick,
        onSecondaryButtonClick: onSecondaryButtonClick,
        primaryButtonProps: primaryButtonProps,
        primaryButtonText: primaryButtonText,
        secondaryButtonProps: secondaryButtonProps,
        secondaryButtonText: secondaryButtonText
      })
    }) : /*#__PURE__*/_jsx(Stack, {
      className: "horizontal-right-aligned-stack",
      gap: 3,
      sx: {
        alignItems: 'center',
        display: 'inline-flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'flex-start',
        padding: padding
      },
      children: isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Stack, {
          flexDirection: 'column-reverse',
          gap: 3,
          justifyContent: "flex-start",
          width: "100%",
          children: /*#__PURE__*/_jsx(ActionButtons, {
            buttonWidthStyle: buttonWidthStyle('vertical'),
            destructive: destructive,
            onPrimaryButtonClick: onPrimaryButtonClick,
            onSecondaryButtonClick: onSecondaryButtonClick,
            primaryButtonProps: primaryButtonProps,
            primaryButtonText: primaryButtonText,
            secondaryButtonProps: secondaryButtonProps,
            secondaryButtonText: secondaryButtonText
          })
        }), /*#__PURE__*/_jsxs(Stack, {
          alignItems: "center",
          display: "inline-flex",
          flex: "1 1 0",
          flexDirection: "row",
          gap: 3,
          justifyContent: "flex-start",
          width: "100%",
          children: [checkbox && /*#__PURE__*/_jsx(Stack, {
            width: !tertiaryButton ? '100%' : '206px',
            children: /*#__PURE__*/_jsx(Checkbox, {
              checked: checked,
              label: checkboxText,
              onChange: onChangeCheckbox,
              size: "sm"
            })
          }), tertiaryButton && /*#__PURE__*/_jsx(Button, {
            onClick: onTertiaryButtonClick,
            size: "large",
            startIcon: icon,
            variant: "link-gray",
            children: tertiaryButtonText
          })]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [checkbox && /*#__PURE__*/_jsx(Checkbox, {
          checked: checked,
          label: checkboxText,
          onChange: onChangeCheckbox,
          size: "sm"
        }), tertiaryButton && /*#__PURE__*/_jsx(Button, {
          onClick: onTertiaryButtonClick,
          size: "large",
          startIcon: icon,
          variant: "link-gray",
          children: tertiaryButtonText
        }), /*#__PURE__*/_jsx(Stack, {
          alignItems: "center",
          display: "inline-flex",
          flex: "1 1 0",
          flexDirection: "row",
          gap: 3,
          justifyContent: "flex-end",
          width: "fit-content",
          children: /*#__PURE__*/_jsx(ActionButtons, {
            buttonWidthStyle: buttonWidthStyle('horizontal'),
            destructive: destructive,
            onPrimaryButtonClick: onPrimaryButtonClick,
            onSecondaryButtonClick: onSecondaryButtonClick,
            primaryButtonProps: primaryButtonProps,
            primaryButtonText: primaryButtonText,
            secondaryButtonProps: secondaryButtonProps,
            secondaryButtonText: secondaryButtonText
          })
        })]
      })
    })]
  });
}